import SupportAgent from "@mui/icons-material/SupportAgent";
import Typography from "@mui/material/Typography";
import PageContainer from "../components/Common/PageContainer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";
import InternalError from "../components/Errors/InternalError";
import FeatureCards from "../components/FeatureCards";
import Loading from "../components/Loading";
import { useBots } from "../components/Sirius/SiriusQueries";

function AgentsPage() {
  const { data: bots, isLoading, isError } = useBots();
  const features = bots
    ? bots.map((bot) => {
        return {
          title: bot.name,
          path: `/sirius/bot/${bot.id}`,
          icon: <SupportAgent sx={{ fontSize: 40 }} />,
          children: <Typography>{bot.description}</Typography>,
        };
      })
    : [];

  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        {isError ? (
          <InternalError />
        ) : isLoading ? (
          <Loading />
        ) : features.length > 0 ? (
          <FeatureCards features={features} />
        ) : (
          <Typography>Aucun agent disponible</Typography>
        )}
      </PageContainer>
    </DashboardLayout>
  );
}

export default AgentsPage;
